<div class="card card-custom gutter-b">
    <div class="card-body">
        <!-- begin: Filtration form -->
        <div class="form form-label-right">
            <div class="form-group row">
                <div class="col-lg-4">
                    <div class="row" [formGroup]="filterGroup">
                        <div class="col-lg-6">
                            <select class="form-control" name="status" placeholder="Filter nach Status" formControlName="status">
                                <option value="">Alle</option>
                                <option value="1">Nur für Internet</option>
                                <option value="2">Nicht für Internet</option>
                            </select>
                            <small class="form-text text-muted"><b>Filter</b> nach Status</small>
                        </div>
                        <div class="col-lg-6">
                            <select class="form-control" placeholder="Filter nach Reihenfolge" name="sequence" formControlName="sequence">
                                <option *ngFor="let rf of reihenfolge" [value]="rf.value">{{ rf.level }}</option>
                            </select>
                            <small class="form-text text-muted"><b>Filter</b> nach Reihenfolge</small>
                        </div>
                    </div>
                </div>
                <div class="col-lg-2" [formGroup]="searchGroup">
                    <input type="text" class="form-control" name="searchText" placeholder="Suche" value="" formControlName="searchTerm" />
                    <small class="form-text text-muted"><b>Suche</b> in allen Feldern</small>
                </div>
            </div>
        </div>
        <!-- end: Filtration form -->

        <div class="table-responsive angular-bootstrap-table">
            <table class="table table-head-custom table-vertical-center overflow-hidden">
                <thead>
                    <th>
                        NUMMER
                    </th>
                    <th>
                        NAME
                    </th>
                    <th>
                        REIHENFOLGE WEB
                    </th>
                    <th>
                        INTERNET
                    </th>
                    <th>
                        ACTIONS
                    </th>
                </thead>
                <tbody>
                    <tr *ngFor="let artikelGruppe of artikelGruppen">
                        <td>{{ artikelGruppe.nummer }}</td>
                        <td>{{ artikelGruppe.name }}</td>
                        <td>{{ artikelGruppe.reihenfolgeWeb }}</td>
                        <td>
                            <div class="custom-control custom-switch">
                                <input [ngModel]="artikelGruppe.internet_JN == 'J'" type="checkbox" disabled class="custom-control-input" id="customSwitch1">
                                <label class="custom-control-label" for="customSwitch1"></label>
                            </div>
                        </td>
                        <!-- <td>{{ artikelGruppe.internet_JN }}</td> -->
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row">
            <div class="col">
                <ngb-pagination class="d-flex justify-content-end px-2"
                    [collectionSize]="maxItems" 
                    [(page)]="page" 
                    [pageSize]="selectedOption"
                    [maxSize]="5" 
                    [rotate]="true" 
                    [ellipses]="true" 
                    [boundaryLinks]="true"
                    (pageChange)="loadPage($event)">
                </ngb-pagination>
            </div>
            <div class="col">
                <mat-form-field class="px-4 mt-n2">
                    <mat-select [(value)]="selectedOption" (selectionChange)="pageSizeChanged($event)">
                        <mat-option *ngFor="let option of options" 
                            value={{option}}>{{option}} Einträge/Seite
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>
</div>